import { subjectStudyData } from './subjectStudyData';

export { subjectStudyData };

export interface Subject {
  id: string;
  name: string;
  shortName: string;
  color: string;
  icon: string;
  grades: ('10' | '11' | '12')[];
  description: string;
  lessonCount: number;
  lastScanned: string;
  scanCount: number;
  addedAt: string;
}

export const saSubjects: Subject[] = [
  {
    id: 'math',
    name: 'Mathematics',
    shortName: 'Maths',
    color: '#C0392B',
    icon: 'ri-function-line',
    grades: ['10', '11', '12'],
    description: 'From algebra and functions to advanced calculus and probability',
    lessonCount: 42,
    lastScanned: '',
    scanCount: 0,
    addedAt: '2026-02-15T10:00:00Z',
  },
  {
    id: 'physics',
    name: 'Physical Science',
    shortName: 'Physics',
    color: '#E67E22',
    icon: 'ri-flashlight-line',
    grades: ['10', '11', '12'],
    description: 'Vectors, forces, electricity, chemical reactions, waves, and circuits',
    lessonCount: 38,
    lastScanned: '',
    scanCount: 0,
    addedAt: '2026-02-20T14:30:00Z',
  },
  {
    id: 'life-sciences',
    name: 'Life Sciences',
    shortName: 'Life Sci',
    color: '#27AE60',
    icon: 'ri-dna-line',
    grades: ['10', '11', '12'],
    description: 'Cells, DNA, genetics, human body systems, evolution, and ecology',
    lessonCount: 35,
    lastScanned: '',
    scanCount: 0,
    addedAt: '2026-03-01T09:15:00Z',
  },
  {
    id: 'accounting',
    name: 'Accounting',
    shortName: 'Acc',
    color: '#8E44AD',
    icon: 'ri-calculator-line',
    grades: ['10', '11', '12'],
    description: 'Ledger accounts, journals, financial statements, VAT, cash flow',
    lessonCount: 28,
    lastScanned: '',
    scanCount: 0,
    addedAt: '2026-03-10T16:00:00Z',
  },
];

export const savedSubjects = saSubjects;

// Production: no demo scans. Real user scans populate this dynamically.
export const recentScans: Array<{
  id: string;
  title: string;
  subject: string;
  date: string;
  type: string;
  pages: number;
  questionsDetected: number;
}> = [];

// Production: no demo chat messages. AI Assistant starts fresh for each user.
export const aiChatMessages: Array<{
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}> = [];

// Production: no pre-generated AI responses. Assistant generates fresh replies.
export const aiResponses: string[] = [];